import { loadComponent } from '../lib/react-utils';

const Main = loadComponent({ loader: () => import('./pages/main') });
const Entries = loadComponent({ loader: () => import('./pages/entries') });
const Login = loadComponent({ loader: () => import('./pages/login') });
const AnonymousLogin = loadComponent({ loader: () => import('./pages/anonymous-login') });
const Logout = loadComponent({ loader: () => import('./pages/logout') });
const ReplyExample = loadComponent({ loader: () => import('./pages/reply-example') });
const Maintain = loadComponent({ loader: () => import('./pages/maintain') });
const NotFound = loadComponent({ loader: () => import('./pages/404') });
const ConversationOver = loadComponent({ loader: () => import('./pages/conversation-over') });

export const RouteKeyEnums = {
	REPLY_EXAMPLE: '/reply-example',
	MAIN: '/',
	ENTRIES: '/entries',
	LOGIN: '/login',
	ANONYMOUS_LOGIN: '/anonymous-login',
	LOGOUT: '/logout',
	MAINTAIN: '/maintain',
	NOT_FOUND: '/404',
	CONVERSATION_OVER: '/conversation-over',
};

export const SYSTEM_ROUTE_KEYS = [
	RouteKeyEnums.LOGIN,
	RouteKeyEnums.LOGOUT,
	RouteKeyEnums.MAINTAIN,
	RouteKeyEnums.NOT_FOUND,
	RouteKeyEnums.CONVERSATION_OVER,
	RouteKeyEnums.ANONYMOUS_LOGIN,
];

export function checkIsSystemRoutePath(pathname = '') {
	return SYSTEM_ROUTE_KEYS.some(routePath => {
		// 1. 完全相等 (例如 /login === /login)
		if (pathname === routePath) {
			return true;
		}

		// 2. 處理路徑後方帶斜線的情況 (例如 /login/ 符合 /login)
		// 確保不會誤判 /login-extra 為 /login
		return pathname.startsWith(`${routePath}/`);
	});
}

const {
	REPLY_EXAMPLE,
	MAIN,
	ENTRIES,
	LOGIN,
	ANONYMOUS_LOGIN,
	LOGOUT,
	MAINTAIN,
	NOT_FOUND,
	CONVERSATION_OVER,
} = RouteKeyEnums;
const routes = [
	{
		path: REPLY_EXAMPLE,
		exact: true,
		component: ReplyExample,
	},
	{
		path: LOGIN,
		component: Login,
		routes: [
			{
				path: `${LOGIN}?code=:code`,
				component: Login,
				paramProps: {
					code: ':code',
				},
			},
		],
	},
	{
		path: ANONYMOUS_LOGIN,
		component: AnonymousLogin,
		routes: [
			{
				path: `${ANONYMOUS_LOGIN}?clientLoginCode=:clientLoginCode`,
				component: AnonymousLogin,
				paramProps: {
					clientLoginCode: ':clientLoginCode',
				},
			},
		],
	},
	{
		path: ENTRIES,
		component: Entries,
	},
	{
		path: LOGOUT,
		component: Logout,
	},
	{
		path: MAINTAIN,
		component: Maintain,
	},
	{
		path: CONVERSATION_OVER,
		component: ConversationOver,
		exact: true,
	},
	{
		path: NOT_FOUND,
		component: NotFound,
		routes: [],
	},
	{
		path: MAIN,
		component: Main,
	},
];

export default routes;
